<template>
  <footer class="site-footer">
    <!-- <div class="text-left" style="display: flex;">
      © 2020 Cash Now&nbsp;<div>Initiated by<strong>&nbsp;<a href="https://craterapp.com/">Crater</a></strong> - Powered by <strong><a href="https://softpyramid.com/">Soft Pyramid</a></strong></div>
    </div> -->
  </footer>
</template>

<script type="text/babel">
export default {
  data () {
    return {
      footer: 'footer'
    }
  }
}
</script>
